export const getPathMatchLength = (pathname: string, path: string): number => {
  if (path === '/') return pathname === '/' ? 1 : 0;

  if (pathname === path || pathname.startsWith(`${path}/`)) return path.length;

  const idx = pathname.lastIndexOf(path);
  if (idx > 0) {
    const afterMatch = pathname[idx + path.length];
    if (afterMatch === undefined) return pathname.length;
    if (afterMatch === '/') return path.length;
  }

  return 0;
};
